import { IdentityButtonVariant } from "./types";

export interface IdentityButtonProps {
  label: string;
  loading?: boolean;
  variant?: IdentityButtonVariant;
  type?: "button" | "submit";
  disabled?: boolean;
  onClick?: () => void;
}

export function IdentityButton({
  label,
  loading,
  variant = "primary",
  type = "button",
  disabled,
  onClick,
}: IdentityButtonProps) {
  return (
    <button
      type={type}
      className="sc-identity-btn"
      data-variant={variant}
      disabled={disabled || !!loading}
      onClick={onClick}
      aria-busy={!!loading}
    >
      {loading ? (
        <span style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem" }}>
          <span className="sc-identity-spinner" aria-hidden />
          {label}
        </span>
      ) : (
        label
      )}
    </button>
  );
}
